module.exports = __webpack_public_path__ + "static/img/jingmai_chat.ef752a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/jingmai_chat.png
// module id = 1722
// module chunks = 0